import React from 'react';
import "../../styles/pages/Other/NoPage.css"

const NoPage = () => {
    return (
        <div className='nopage-content'>
            <span>404 - page not found</span>
        </div>
    );
};

export default NoPage;